var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Quill from 'quill';
var embed = Quill.import('blots/embed');
var VideoAssetEmbed = /** @class */ (function (_super) {
    __extends(VideoAssetEmbed, _super);
    function VideoAssetEmbed() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VideoAssetEmbed.create = function (asset) {
        var node = _super.create.call(this);
        node.setAttribute('src', asset.uri);
        node.setAttribute('type', asset.type);
        node.setAttribute('data-id', asset.id);
        node.setAttribute('controls', true);
        node.classList.add('w-full', 'relative');
        return node;
    };
    VideoAssetEmbed.blotName = 'VideoAssetEmbed';
    VideoAssetEmbed.className = 'video-asset';
    VideoAssetEmbed.tagName = 'video';
    return VideoAssetEmbed;
}(embed));
export { VideoAssetEmbed };
